export enum SkinTone {
  LIGHTEST = '#FFC99C',
  LIGHT = '#DFA982',
  MEDIUM = '#BF916D',
  DARK = '#97665C',
  DARKEST = '#7C5235',
  GREEN = '#0FD23A',
}

const defaultColors: Record<string, string> = {
  'char-upload-Axel': SkinTone.MEDIUM,
  'char-upload-Expo': SkinTone.LIGHT,
  'char-upload-Grace': SkinTone.LIGHT,
  'char-upload-Lin': SkinTone.DARK,
  'char-upload-Mani': SkinTone.MEDIUM,
  'char-upload-Mark': SkinTone.DARKEST,
  'char-upload-Math': SkinTone.LIGHT,
  'char-upload-Matt': SkinTone.LIGHT,
  'char-upload-Max': SkinTone.DARKEST,
  'char-upload-Mo': SkinTone.LIGHT,
  'char-upload-Nadia': SkinTone.MEDIUM,
  'char-upload-Nash': SkinTone.LIGHTEST,
  'char-upload-Nat': SkinTone.DARKEST,
  'char-upload-Phoebe': SkinTone.LIGHT,
  'char-upload-Q': SkinTone.LIGHT,
  'char-upload-Ray': SkinTone.LIGHTEST,
  'char-upload-Shannon': SkinTone.DARKEST,
  'char-upload-Subtra': SkinTone.DARKEST,
  'char-upload-Tan': SkinTone.LIGHTEST,
  'char-upload-Tess': SkinTone.MEDIUM,
  'char-upload-Tori': SkinTone.LIGHTEST,
  '': SkinTone.MEDIUM,
};

export default function defaultSkinTone(
  value: string | undefined,
  charUploadID: string | undefined,
) {
  if (!value || value === 'default') {
    return defaultColors[charUploadID ?? ''] || SkinTone.MEDIUM;
  }
  return value;
}
